
class Vector3 {
  x: number;
  y: number;
  z: number;
  constructor(x: number, y: number, z: number) {
    this.x = x;
    this.y = y;
    this.z = z;
  }
}

class Point {
  x: number;
  y: number;
  z: number;
  constructor(x: number, y: number, z: number, chipLengthY: number) {
    this.x = x;
    this.y = chipLengthY - y;
    this.z = z;
  }
}

abstract class PayloadShape {
  fill: boolean;
  height?: number;
  constructor(fill: boolean, height?: number) {
    this.fill = fill;
    if (height) this.height = height;
  }
}

class PayloadPolygon extends PayloadShape {
  type = "Polygon";
  points: Point[];
  direction: Point;
  reflowRadius: number;
  constructor(
    points: Point[],
    fill: boolean,
    dir_X: number,
    dir_Y: number,
    dir_Z: number,
    reflowRadius?: number
  ) {
    super(fill);
    this.points = points;
    this.direction = new Vector3(dir_X, -dir_Y, dir_Z);
    if (reflowRadius) this.reflowRadius = reflowRadius; 
    else this.reflowRadius = 0;
  }
}

class PayloadCircle extends PayloadShape {
  type = "Circle";
  center: Point;
  radius: number;
  reflowRadius: number;
  constructor(center: Point, fill: boolean, height: number, radius: number, reflowRadius?: number) {
    super(fill, height);
    this.center = center;
    this.radius = radius;
    if (reflowRadius) this.reflowRadius = reflowRadius; 
    else this.reflowRadius = 0;
  }
}

class PayloadLine {
  fill = true;
  type = "Line";
  start: Point;
  end: Point;
  height: number;
  width: number;
  reflowRadius: number;
  constructor(start: Point, end: Point, width: number, height: number, reflowRadius?: number) {
    this.start = start;
    this.end = end;
    this.width = width;
    this.height = height;
    if (reflowRadius) this.reflowRadius = reflowRadius; 
    else this.reflowRadius = 0;
  }
}

// width : parallel to the plane
// height ：perpendicular to the plane
class PayloadCurve extends PayloadLine {
  type = "Curve";
  center: Point;
  corner: Point;
  tangent: Point;
  reflowRadius: number;
  constructor(
    center: Point,
    start: Point,
    end: Point,
    corner: Point,
    width: number,
    height: number,
    reflowRadius?: number
  ) {
    super(start, end, width, height);
    this.center = center;
    this.corner = corner;
    this.tangent = new Vector3(
      (corner.x - start.x) / 1000,
      (corner.y - start.y) / 1000,
      (corner.z - start.z) / 1000
    );
    if (reflowRadius) this.reflowRadius = reflowRadius; 
    else this.reflowRadius = 0;
  }
}

class PayloadHill {
  fill = true;
  type = "Hill";
  points: Point[];
  width: number;
  height: number;
  constructor(points: Point[], width: number, height: number) {
    this.points = points;
    this.width = width;
    this.height = height;
  }
}

class PayloadChannel {
  shapes: (PayloadLine | PayloadCircle)[];
  constructor(shapes: (PayloadLine | PayloadCircle)[]) {
    this.shapes = shapes;
  }
}

class PayloadChannelWithHill {
  shapes: (PayloadLine | PayloadCircle | PayloadHill)[];
  constructor(shapes: (PayloadLine | PayloadCircle | PayloadHill)[]) {
    this.shapes = shapes;
  }
}

export {
  Point,
  Vector3,
  PayloadCircle,
  PayloadPolygon,
  PayloadShape,
  PayloadLine,
  PayloadCurve,
  PayloadChannel,
  PayloadHill,
  PayloadChannelWithHill
};
